import { Serializable } from './deserialize.service';

export class ResultSet implements Serializable<ResultSet> {
    surveyId: string;
    createdBy: string;
    createdDate: Date;
    content: string;
    title: string;
    sortId: string;

    deserialize(input) {
        this.surveyId = input.surveyId;
        this.createdBy = input.createdBy;
        this.createdDate = input.createdDate;
        this.content = input.content;
        this.title = input.title;
        this.sortId = input.sortId;
        return this;
    }
}
// public class Comment {
//     public String id;
//     public Date commentAdded;
//     public String comment;
